import {
  GET_SERVICES_AGENDA_TEAM,
  TOGGLE_CREATE_ERP,
  TOGGLE_CREATE_SERVICES,
} from "../constants";
import { IERPRequest, IService } from "../reducers";

export function createServices(
  services: IService[],
  resolve: any,
  reject: any,
) {
  return { type: TOGGLE_CREATE_SERVICES, services, resolve, reject };
}

export function createERP(erp: IERPRequest, resolve: any, reject: any) {
  return { type: TOGGLE_CREATE_ERP, erp, resolve, reject };
}

export function getServicesAgendaTeam(
  startDate: string,
  endDate: string,
  resolve: any,
  reject: any,
  agencyId: string,
) {
  return {
    type: GET_SERVICES_AGENDA_TEAM,
    payload: { startDate, endDate, agencyId },
    resolve,
    reject,
  };
}
